import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "text-tile-border my-2"
}
const _hoisted_2 = ["textContent"]

import {Design} from "../../../../DesignSystem/design";
import Icon from "../../../../Icon/Icon.vue";
import {IconName} from "../../../../Icon/icons";
import {NavigationAction} from "../../../Port/NavigationService";
import MessageCount from "../MessageCount.vue";
import NavigationLink from "../NavigationLink.vue";

interface Props {
  type: 'link'|'buttonPrimary'|'buttonSecondary'|'username'|'separatorDesktop'|'separatorMobile'|'spaceMobile';
  icon?: IconName;
  title?: string;
  messagesCount?: number;
  action?: NavigationAction;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopMenuListItem',
  props: {
    type: {},
    icon: {},
    title: {},
    messagesCount: {},
    action: {}
  },
  emits: ['action'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function click(): void {
  emit('action', props.action);
}

function action(): void {
  emit('action', props.action);
}

return (_ctx: any,_cache: any) => {
  return (props.type === 'link' || props.type === 'buttonSecondary')
    ? (_openBlock(), _createBlock(NavigationLink, {
        key: 0,
        class: "flex justify-between items-center hover:text-green2-600 cursor-pointer py-2",
        action: props.action,
        onAction: action
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.title) + " ", 1 /* TEXT */),
          (props.messagesCount)
            ? (_openBlock(), _createBlock(MessageCount, {
                key: 0,
                "messages-count": props.messagesCount
              }, null, 8 /* PROPS */, ["messages-count"]))
            : (props.icon)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 1,
                  name: props.icon,
                  monospace: ""
                }, null, 8 /* PROPS */, ["name"]))
              : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["action"]))
    : (props.type === 'buttonPrimary')
      ? (_openBlock(), _createBlock(_unref(Design).Button, {
          key: 1,
          primary: "",
          class: "px-10 my-2",
          title: props.title,
          onClick: click
        }, null, 8 /* PROPS */, ["title"]))
      : (props.type === 'separatorDesktop')
        ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
        : (props.type === 'separatorMobile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64 /* STABLE_FRAGMENT */))
          : (props.type === 'spaceMobile')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [], 64 /* STABLE_FRAGMENT */))
            : (props.type === 'username')
              ? (_openBlock(), _createBlock(NavigationLink, {
                  key: 5,
                  class: "flex justify-baseline cursor-pointer py-1",
                  action: props.action,
                  onAction: action
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "text-neutral2-700 font-semibold min-w-44",
                      textContent: _toDisplayString(props.title)
                    }, null, 8 /* PROPS */, _hoisted_2),
                    (props.icon)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          name: props.icon,
                          monospace: ""
                        }, null, 8 /* PROPS */, ["name"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["action"]))
              : _createCommentVNode("v-if", true)
}
}

})